module.exports = __webpack_public_path__ + "img/Alfonso.fe05a7e2.jpg";